import React from 'react';
import { track } from '../analytics';

// Update this to your Ko-fi username (https://ko-fi.com/<username>)
export const KOFI_USERNAME = 'pkchampscoach';

function CoffeeIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M4 9h11v6a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V9Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <path d="M15 11h2a3 3 0 0 1 0 6h-2" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <path d="M7 3.5c0 1 1 1.3 1 2.3s-1 1.2-1 2.2M10.5 3.5c0 1 1 1.3 1 2.3s-1 1.2-1 2.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

function KoFiButton({ variant = 'default', username = KOFI_USERNAME, label = 'Support the project' }) {
  const href = `https://ko-fi.com/${username}`;
  return (
    <a
      className={`kofi-btn kofi-btn-${variant}`}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Tip PK Champs Coach on Ko-fi`}
      onClick={() => track('kofi_click', { variant })}
    >
      <CoffeeIcon size={variant === 'compact' ? 14 : 16} />
      {label && <span>{label}</span>}
    </a>
  );
}

export default KoFiButton;
